export enum MESSAGE_TYPE  {
    PLUGIN_READY = 'PLUGIN_READY',
    PLUGIN_INIT = 'PLUGIN_INIT',
    PLUGIN_RENDER = 'PLUGIN_RENDER',
    UI_MESSAGE = 'UI_MESSAGE',
}

export default MESSAGE_TYPE